export const authService = {
    getUserInfo: () => {
        return {
            company_code: localStorage.getItem('company_code') as string | undefined,
            user_code: localStorage.getItem('user_code') as string | undefined,
            user_name: localStorage.getItem('user_name') as string | undefined,
            user_role: localStorage.getItem('role') as string | undefined,
            token: localStorage.getItem('token') as string | undefined,
        }
    },

    setUserInfo: (data: any) => {
        const { token, user_code, company_code, user_role, user_name, } = data;

        localStorage.setItem('company_code', company_code);
        localStorage.setItem('user_code', user_code);
        localStorage.setItem('user_name', user_name);
        localStorage.setItem('role', user_role);
        localStorage.setItem('token', token);
    },

    removeUserInfo: () => {
        localStorage.removeItem('company_code');
        localStorage.removeItem('user_code');
        localStorage.removeItem('user_name');
        localStorage.removeItem('role');
        localStorage.removeItem('token');
    },
};


